import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import moment from 'moment';

const ChlorineChart = ({ data }) => {
  const dataArray = data.map((r) => {
    return {
      date: moment(r.timestamp).local().format('M/DD'),
      free: r.freeChlorine,
      total: r.totalChlorine,
    };
  });
  const reversedData = dataArray.reverse();

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={reversedData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="date" padding={{ left: 5 }} />
        <YAxis
          domain={[0, 3.5]}
          allowDecimals={true}
          ticks={[0.0, 0.5, 1.0, 1.5, 2.0, 2.5, 3, 3.5]}
        />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Legend />
        <Line
          name="Free"
          dataKey="free"
          type="monotone"
          stroke="#7A1018"
          strokeWidth={2}
        />
        <Line
          name="Total"
          dataKey="total"
          type="monotone"
          stroke="#12198C"
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

ChlorineChart.propTypes = {
  data: PropTypes.array,
};

export default ChlorineChart;



// WEBPACK FOOTER //
// ./src/components/reading/charts/ChlorineChart.js